export { default } from '../../menu-item/link-item';
